import { render } from "./portal_roles.html?vue&type=template&id=7b8f7fed&external"
import script from "./portal_roles.js?vue&type=script&lang=js&external"
export * from "./portal_roles.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__